








































































import AbpBase from "../../../lib/abpbase";
import { Component, Vue,Inject, Prop,Watch } from 'vue-property-decorator';
import Util from '../../../lib/util'
import {GetRecipeData,Prescribe,LoadChangeBeds,ChangeBed} from '../../../api/dialysisProcess'
import {GetWardList,GetShiftList} from '../../../api/specialDictionary'
import util from '../../../lib/util'

@Component({
    components:{}
})
export default class  extends AbpBase{
    @Prop({type:Boolean,default:false}) value:boolean;
    @Prop({type:Object,default:{}}) data:any;

    //左右tabs
    tabsShow = 0
    wardList:any = []
    shiftList:any = []
    shiftActive:any = {}
    wardActive:any = {}
    reason = ''

    list:any = []
    //当前选择
    activeIndex = 0
    //获取病区
    async getWardList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetWardList(data)
        this.wardList = res.items
        console.log()
        this.wardActive.id = this.data.bedId
    }
    //获取班次
    async getShiftList(){
        let data = {
            QueryString:'',
            SkipCount:1,
            MaxResultCount:10000
        }
        let res = await GetShiftList(data)
        this.shiftList = res.items
         //根据当时时间自动选择班次
        this.shiftList.forEach((item:any)=>{
            var curTime = new Date();
            var endTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.eddate));
            var startTime = new Date(Date.parse(util.dateConversion(new Date())+' '+item.stdate));
            console.log(curTime<=endTime)
            if(curTime>=startTime && curTime<=endTime){
                this.shiftActive = item
            }
        })
    }
    //获取床位信息
    async getData(){
        let data = {
            changeBedType:this.tabsShow,
            bedId:this.data.bedId,
            shiftId:this.shiftActive.id,
            wardId:this.wardActive.id,
        }
        let res = await LoadChangeBeds(data)
        this.list = res.objects
    }
    async created() {
        await this.getWardList()
        await this.getShiftList()
        await this.getData()
    }

    async save(){
        let data = {
            patientId:this.data.patientId,
            changeBedType:this.tabsShow,
            nowBedId:this.list[this.activeIndex].nowBedId,
            nowBedCode:this.list[this.activeIndex].nowBedCode,
            reason:this.reason
        }
        let res = await ChangeBed(data)
        this.$emit('input',false);
        this.$emit('on-back')
    }
    cancel(){
        (this.$refs.roleForm as any).resetFields();
        this.$emit('input',false);
    }
    visibleChange(value:boolean){
        if(!value){
            this.$emit('input',value);
        }
    }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/views/dialysisProcess/dialysisArea/changeBed.vue